import { jsx as _jsx } from "react/jsx-runtime";
import { useScreenWidth } from "../hooks/useScreenWidth.js";
import { useFormatting } from "../formatting/useFormatting.js";
import { LabeledValue } from "../labeled-values/LabeledValue.js";
import { Paper, Stack } from "@mui/material";
import { LabeledValueHorizontal } from "../labeled-values/LabeledValueHorizontal.js";
export const TableAggregates = ({ aggregates }) => {
    const { isMaxPhone } = useScreenWidth();
    const { getFormattedPrice } = useFormatting();
    const aggregatesToShow = aggregates.filter(a => a.value !== undefined);
    if (!aggregatesToShow.length)
        return null;
    return (_jsx(Paper, { children: _jsx(Stack, { direction: "row", paddingY: 0.5, paddingX: 1, spacing: 2, children: aggregatesToShow.map(({ label, color, value }, index) => !isMaxPhone ? (_jsx(LabeledValueHorizontal, { label: label, labelProps: { color }, children: getFormattedPrice(value) }, index)) : (_jsx(LabeledValue, { label: label, labelProps: { color }, children: getFormattedPrice(value) }, index))) }) }));
};
//# sourceMappingURL=TableAggregates.js.map